import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Row,
    Col,
    Form,
} from "reactstrap";
import {
	TextField,
	MenuItem,InputLabel,FormControl,Input
} from "@mui/material";
import CustomButton from "../../../components/CustomButton/CustomButton.jsx";
import LoaderButton from "../../../components/CustomButton/LoaderButton";
// import FormControl from "@mui/material/FormControl";
// import InputLabel from "@mui/material/InputLabel";
// import Input from "@mui/material/Input";
import { resetbankBranchList, bankBranchList } from "../../../redux/actions/bankBranchListAction";
import { resetbankMasterAddUpdate, bankMasterAddUpdate } from "../../../redux/actions/bankMasterAddUpdateAction.js"

function AddNewBank({action}) {

  const [ bankName, setbankName] = useState("");
  const [ bankCode, setbankCode] = useState("");
  const [ branchName, setbranchName] = useState("");
  const [ branchCode, setbranchCode] = useState("");
  const [ districtName, setdistrictName] = useState("");
  const [ districtCode, setdistrictCode] = useState("");
  const [ accountNumber, setaccountNumber] = useState("");
  const [ routingNumber, setroutingNumber] = useState("");

  const dispatch = useDispatch();

  console.log("trial", action)

  const login = useSelector(({ login }) => login);
  const bankbranchlist = useSelector(({ bankBranchlist }) => bankBranchlist);
  const banknamelist = useSelector(({ bankNamelist }) => bankNamelist);
  const bankdistrictlist = useSelector(({ bankDistrictlist }) => bankDistrictlist);
  const bankmasterview = useSelector(({ bankMasterview }) => bankMasterview);
  const bankMasteraddupdate = useSelector(({ bankMasterAddUpdate }) => bankMasterAddUpdate);
  const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

  const handleSubmit = (e) => {
    e.preventDefault();
    const req = {
        actionCustomerMasterRequestVO : {
            id: action === "updateBankMaster" ? bankmasterview.data.viewMgtList.bankId : "",
            bankId : login.data.partnerId,
            bankName,
            bankCode,
            branchName,
            branchCode,
            district: districtName,
            districtCode,
            accountNumber,
            routingCode: routingNumber,
        }
    }

    console.log(req)
    if(regenerateTokenRes.success){
        dispatch(bankMasterAddUpdate(req, regenerateTokenRes.data.AuthToken));
    }
  }
  
  const handleChange = ({ target: { value, name } }) => {
    if(name === "bankName"){
        setbankName(value);
        setbankCode(banknamelist.data.errorList.find((x) => x.name === value).code)
    }

    if(name === "branchName"){
        setbranchName(value);
        setbranchCode(bankbranchlist.data.errorList.find((x) => x.name === value).code)
    }

    if(name === "districtName"){
        setdistrictName(value);
        setdistrictCode(bankdistrictlist.data.errorList.find((x) => x.name === value).code)
    }

    if(name === "accountNumber"){
        setaccountNumber(value);
    }

    if(name === "routingNumber"){
        setroutingNumber(value)
    }

  }

  const disabledButton = () => {
    return !(bankName && bankCode && branchName && branchCode && districtCode && districtName && accountNumber && routingNumber);
  }

  useEffect(() => {
    if(regenerateTokenRes.success && bankCode.length){
        const req = {
            actionCustomerMasterRequestVO: {
                bankId : login.data.partnerId,
                bankCode,
            }
        }
    
        dispatch(bankBranchList(req, regenerateTokenRes.data.AuthToken));
    }
  }, [regenerateTokenRes.success, bankCode])

  useEffect(() => {
    if((action === "viewBankMaster" || action === "updateBankMaster") && bankmasterview.success){
        setbankName(bankmasterview.data.viewMgtList.bankName);
        setbankCode(bankmasterview.data.viewMgtList.bankCode)
        setbranchName(bankmasterview.data.viewMgtList.branchName);
        setbranchCode(bankmasterview.data.viewMgtList.branchCode);
        setdistrictName(bankmasterview.data.viewMgtList.district);
        setdistrictCode(bankmasterview.data.viewMgtList.districtCode);
        setaccountNumber(bankmasterview.data.viewMgtList.accountNumber);
        setroutingNumber(bankmasterview.data.viewMgtList.routingCode);
    }
  },[action, bankmasterview])

  useEffect(() => {
    return () => {
        setbankName("");
        setbankCode("");
        setbranchName("");
        setbranchCode("");
        setdistrictName("");
        setdistrictCode("");
        setaccountNumber("");
        setroutingNumber("");
        dispatch(resetbankMasterAddUpdate());
    }
  },[]);


  return (
    <Form onSubmit={handleSubmit}>
        <Row style={{
            padding: "0px 25px",
            marginBottom: "25px"
        }}>
            <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                                                    
                <FormControl required fullWidth>
                <TextField
								select
								size="small"
								color="primary"
								type="select"
								label="Bank Name"
								fullWidth={true}
								name="bankName"
                                disabled={action === "viewBankMaster" ? "disabled" : ""}
                                //selected={bankName}
                                value={bankName}
								//defaultValue={bankName}
								onChange={handleChange}
							>
								<MenuItem value="" key="bank" selected="Select Bank Name">
									Select Bank Name
								</MenuItem>
								{banknamelist.success &&
									[]
										.concat(banknamelist.data.errorList)
										.map((x) => <MenuItem key={x.name} value={x.name}>{x.name}</MenuItem>)}
							</TextField>
                </FormControl>
            </Col>
            <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                                                    
                <FormControl required fullWidth>
                    <InputLabel htmlFor="bankCode">
                        Bank Code
                    </InputLabel>
                    <Input
                        id="bankCode"
                        value={bankCode}
                        onChange={handleChange}
                        name="bankCode"
                        disabled={action === "viewBankMaster" ? "disabled" : ""}
                        required
                    />
                </FormControl>
            </Col>
            <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
            <TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Branch Name"
								fullWidth={true}
								name="branchName"
                                value={branchName}
								//defaultValue={branchName}
                                //selected={branchName}
                                disabled={action === "viewBankMaster" ? "disabled" : ""}
								onChange={handleChange}
							>
								<MenuItem
									value=""
                                    key="branch"
									selected="Select Branch Name"
								>
									Select Branch Name
								</MenuItem>
								{bankbranchlist.success &&
									[]
										.concat(bankbranchlist.data.errorList)
										.map((x) => <MenuItem key={x.name} value={x.name}>{x.name}</MenuItem>)}
							</TextField>
            </Col>
            <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                                                    
                <FormControl required fullWidth>
                    <InputLabel htmlFor="branchCode">
                        Branch Code
                    </InputLabel>
                    <Input
                        id="branchCode"
                        value={branchCode}
                        onChange={handleChange}
                        disabled={action === "viewBankMaster" ? "disabled" : ""}
                        name="branchCode"
                        required
                    />
                </FormControl>
            </Col>
            <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                                                    
            <TextField
								select
								size="small"
								color="primary"
								type="text"
								label="District Name"
								fullWidth={true}
								name="districtName"
                                value={districtName}
								//defaultValue={districtName}
                                disabled={action === "viewBankMaster" ? "disabled" : ""}
								onChange={handleChange}
							>
								<MenuItem
									value=""
									selected="Select District Name"
                                    key="dist"
								>
									Select District Name
								</MenuItem>
								{bankdistrictlist.success &&
									[]
										.concat(bankdistrictlist.data.errorList)
										.map((x) => <MenuItem key={x.name} value={x.name}>{x.name}</MenuItem>)}
							</TextField>
            </Col>
            <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                                                    
                <FormControl required fullWidth>
                    <InputLabel htmlFor="districtCode">
                        District Code
                    </InputLabel>
                    <Input
                        id="districtCode"
                        value={districtCode}
                        onChange={handleChange}
                        disabled={action === "viewBankMaster" ? "disabled" : ""}
                        name="districtCode"
                        required
                    />
                </FormControl>
            </Col>
            <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                                                    
                <FormControl required fullWidth>
                    <InputLabel htmlFor="accountNumber">
                        Account Number
                    </InputLabel>
                    <Input
                        id="accountNumber"
                        value={accountNumber}
                        onChange={handleChange}
                        name="accountNumber"
                        disabled={action === "viewBankMaster" ? "disabled" : ""}
                        required
                    />
                </FormControl>
            </Col>
            <Col lg={6} md={6} sm={6} style={{ margin: "10px 0" }}>
                                                    
                <FormControl required fullWidth>
                    <InputLabel htmlFor="routingNumber">
                        Routing Number
                    </InputLabel>
                    <Input
                        id="routingNumber"
                        value={routingNumber}
                        onChange={handleChange}
                        name="routingNumber"
                        disabled={action === "viewBankMaster" ? "disabled" : ""}
                        required
                    />
                </FormControl>
            </Col>
        </Row>
        {(action === "updateBankMaster" || action === "addBankMaster") && 
        <Row style={{
            marginBottom: "5px"
        }}>
            <Col md={12} className="d-flex justify-content-center">
                <CustomButton
                    color="primary"
                    className="buttons"
                    round
                    disabled={disabledButton() || bankMasteraddupdate.isLoading}
                    type="submit"
                >
                    <LoaderButton
                        isLoading={bankMasteraddupdate.isLoading}
                        spinner={bankMasteraddupdate.isLoading}
                    >
                        Save
                    </LoaderButton>
                </CustomButton>
            </Col>
        </Row>}
    </Form>
  )
}

export default AddNewBank